import { render, staticRenderFns } from "./InboundMappingsCustomisation.vue?vue&type=template&id=262603dc&"
import script from "./InboundMappingsCustomisation.vue?vue&type=script&lang=ts&"
export * from "./InboundMappingsCustomisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports